import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { GestockService } from '../services/gestock.service';

@Component({
    selector: 'app-edit-cmup',
    templateUrl: './edit-cmup.component.html',
    styleUrls: ['./edit-cmup.component.css']
})
export class EditCMUPComponent implements OnInit {

    newCMUP: number;
    oldCMUP: number;
    articleId: any;
    articleName: string;
    samacaabiyoonwii: string;
    loading: boolean = false;

    constructor(
        public dialogRef: MatDialogRef<EditCMUPComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private gestockService: GestockService,
        private snackBar: MatSnackBar
    ) {
        this.oldCMUP = data.entryPrice;
        //this.newCMUP = data.entryPrice;
        this.articleId = data.id;
        this.articleName = data.name;
        this.samacaabiyoonwii = sessionStorage.getItem("samacaabiyoonwii");
    }

    ngOnInit(): void {
    }

    onCancel(): void {
        this.dialogRef.close();
    }

    isValid(): boolean {
        console.log("le CMUP Saisie: ", this.newCMUP);
        const val = Number(this.newCMUP);
        return !isNaN(val) && val >= 0;
    }

    onSave(): void {
        const cmupValue = Number(this.newCMUP);
        if (cmupValue >= 0 && cmupValue !== this.oldCMUP) {
            this.loading = true;
            this.gestockService.manualUpdateCMUP(this.samacaabiyoonwii, this.articleId, cmupValue)
                .then(response => {
                    this.loading = false;
                    if (response.statutreq == 1) {
                        this.snackBar.open('CMUP mis à jour avec succès', 'Fermer', {
                            duration: 3000,
                            horizontalPosition: 'right',
                            verticalPosition: 'bottom',
                            panelClass: ['custom-snackbar'] // Ensure this class exists or use default
                        });
                        this.dialogRef.close({ newCMUP: this.newCMUP });
                    } else {
                        this.snackBar.open(response.message || 'Erreur lors de la mise à jour', 'Fermer', {
                            duration: 3000,
                            panelClass: ['error-snackbar']
                        });
                    }
                })
                .catch(error => {
                    this.loading = false;
                    console.error("Erreur technique:", error);
                    this.snackBar.open('Erreur technique lors de la mise à jour', 'Fermer', {
                        duration: 3000
                    });
                });
        } else {
            this.snackBar.open('Veuillez entrer une valeur valide et différente de l\'ancienne.', 'Fermer', {
                duration: 3000
            });
        }
    }
}
